<template>
    <div class="flex flex-col gap-6">
        <PageBreadcrumb />

        <CreateTransformsList
            :transform-groups="transformsStore.configs"
            :loading="transformsConfigLoading"
            @select-transform="(item) => selectItem(item)" />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import CreateTransformsList from '@/components/Transforms/CreateTransformsList.vue';
import { useTransformsStore } from '@/stores/transforms.store';
import PageBreadcrumb from '../../components/PageBreadcrumb.vue';

const router = useRouter();
const transformsStore = useTransformsStore();

const transformsConfigLoading = ref(false);

onMounted(async () => {
    try {
        transformsConfigLoading.value = true;

        transformsStore.fetchTransformConfigs().finally(() => {
            transformsConfigLoading.value = false;
        });
    } catch (error) {
        console.error('Error fetching transforms config', error);
    }
});

const selectItem = (child) => {
    router.push({ name: 'create-transform-type', params: { transformType: child.transform } });
};
</script>
